<template>
  <v-card>
    <v-toolbar color="primary" dark>Land editieren</v-toolbar>
    <v-card-text>
      <v-form v-model="valid">
        <v-container>
          <v-row>
            <v-col cols="12" md="6">
              <v-text-field
                v-model="Data.key"
                label="Länder-Kennung"
                required
              ></v-text-field>
            </v-col>
            <v-col cols="12" md="6">
              <v-text-field
                v-model="Data.name"
                :rules="inputRules"
                label="Name"
                required
              ></v-text-field>
            </v-col>

          </v-row>
        </v-container>
      </v-form>
    </v-card-text>
    <v-card-actions class="justify-end">
      <v-btn text @click="Close()">Schließen</v-btn>
      <v-btn tile color="primary" @click="Save(dialog)">Speichern</v-btn>
    </v-card-actions>
  </v-card>
</template>

<script>
export default {
  data() {
    return {
      Data: {
        id: this.country.id,
        key: this.country.key,
        name: this.country.name,
      },
      inputRules: [(v) => !!v || "Pflichtfeld"],
    };
  },
  props: {
    country: null,
  },
  methods: {
    Reset() {
      this.Data.id = null;
      this.Data.key = null;
      this.Data.name = "";
    },
    Close() {
      //this.Reset();
      this.$root.$emit("close_edit_country");
    },
    Save() {
      let dto = {
        id: this.Data.id,
        key: this.Data.key,
        name: this.Data.name,
      };

      this.$store.dispatch("countries/update", dto).then(() => {
        this.$root.$emit("reload_countries_data");
        this.Close();
      });
    },
  },
};
</script>
